import { render } from "./ModFlujosContrato.vue?vue&type=template&id=3bbf95b2"
import script from "./ModFlujosContrato.vue?vue&type=script&lang=js"
export * from "./ModFlujosContrato.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__